export default function ContactSection() {
  return (
    <footer className="relative bg-accent-900 py-20 md:py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-8">
              Contact
            </h2>
            <div className="space-y-5 text-white/80">
              <div>
                <p className="text-xs md:text-sm text-white/50 uppercase tracking-widest mb-1">
                  Address
                </p>
                <p className="text-base md:text-lg text-white/90 leading-relaxed">
                  Naugarduko g. 15-28
                  <br />
                  Vilnius, 03226
                  <br />
                  Lithuania
                </p>
              </div>
              <div>
                <p className="text-xs md:text-sm text-white/50 uppercase tracking-widest mb-1">
                  Phone
                </p>
                <p className="text-base md:text-lg text-white/90">
                  +370 668 03835
                </p>
              </div>
              <div>
                <p className="text-xs md:text-sm text-white/50 uppercase tracking-widest mb-1">
                  Email
                </p>
                <p className="text-base md:text-lg text-white/90">
                  contact@marquerdigital.com
                </p>
              </div>
            </div>
          </div>

          <div className="lg:pt-4">
            <div className="grid grid-cols-2 gap-8 md:gap-10">
              <div>
                <p className="text-xs md:text-sm text-white/50 uppercase tracking-widest mb-4">
                  Location
                </p>
                <p className="text-sm md:text-base text-white/80 leading-relaxed">
                  Vilnius
                </p>
              </div>
              <div>
                <p className="text-xs md:text-sm text-white/50 uppercase tracking-widest mb-4">
                  Country
                </p>
                <p className="text-sm md:text-base text-white/80 leading-relaxed">
                  Lithuania
                </p>
              </div>
              <div>
                <p className="text-xs md:text-sm text-white/50 uppercase tracking-widest mb-4">
                  Focus
                </p>
                <p className="text-sm md:text-base text-white/80 leading-relaxed">
                  iOS Platform
                </p>
              </div>
              <div>
                <p className="text-xs md:text-sm text-white/50 uppercase tracking-widest mb-4">
                  Reach
                </p>
                <p className="text-sm md:text-base text-white/80 leading-relaxed">
                  International
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs md:text-sm text-white/40">
            &copy; {new Date().getFullYear()} All rights reserved.
          </p>
          <p className="text-xs md:text-sm text-white/40">
            contact@marquerdigital.com
          </p>
        </div>
      </div>
    </footer>
  );
}